import React, { useContext, useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faPrint, faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { useMediaQuery } from 'react-responsive';
import appConfig from '../config/appConfig.json'
import EmailModal from './EmailModal';
import { useTranslation } from "react-i18next";
import appContext from '../AppContext';
import { exportToCSV } from '../services/DownloadService';

function Bar(props){
  const [ filtersToggleOn, setFiltersToggleOn ] = useState(false);
  const [ show, setShow ] = useState(false);
  const showFilterOnMobile = useRef(false);
  const { locale, schools, offeringSorts, gradeFilters, searchedPlace } = useContext(appContext);
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ query: `(max-width: 767px)` });
  const schoolYear = appConfig.schoolYear;

  useEffect(() => {
    setFiltersToggleOn(false);
    showFilterOnMobile.current = false;
  }, [isMobile]);

  function filterClickHandler(evt) {
    evt.preventDefault();
    setFiltersToggleOn(!filtersToggleOn);
    showFilterOnMobile.current = !showFilterOnMobile.current;
    props.onToggleFilterOnMobile(showFilterOnMobile.current);
  }

  let printView = () => {
    window.print();
  }

  return (
    <div className="bg-[#E64534] w-full h-[50px] md:flex pt-[1px] md:pt-0 print:h-[40px]">
      <div className='text-white hidden print:hidden md:flex flex-row whitespace-nowrap my-auto cursor-pointer' onClick={() => window.open("https://www.myschooldc.org/","_self")}>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
        </svg>
        <p className='justify-center text-sm'> { t('bar.homepagelink') }</p>
      </div>
      <div className='hidden md:flex align-middle w-full print:block'>
        <p className='justify-center text-2xl text-[#f6d79c] flex-1 items-center flex print:text-center'> { t('bar.title') + " " + schoolYear }</p>
        <div className='flex justify-end items-center print:hidden '>
          <FontAwesomeIcon className='text-[#f6d79c] text-2xl mr-[14px] cursor-pointer' title='Download' icon={faDownload} onClick={(e) => exportToCSV(locale, schools,offeringSorts,gradeFilters, searchedPlace)} />
          <FontAwesomeIcon className='text-[#f6d79c] text-2xl mr-[14px] cursor-pointer' title='Email' icon={faEnvelope} onClick={() => setShow(true)} />
          <FontAwesomeIcon className='text-[#f6d79c] text-2xl mr-[14px] cursor-pointer' title='Print' icon={faPrint} onClick={() => printView()} />
        </div>
      </div>
      <div className='flex flex-row justify-between items-center md:hidden print:hidden h-full'>
        <div>
          <FontAwesomeIcon className='text-[#f6d79c] pl-3 cursor-pointer' title='Search' icon={filtersToggleOn? faXmark: faBars}   onClick={(evt) => filterClickHandler(evt)} />
          <span className='ml-[10px] text-[14px] text-[#f6d79c]' onClick={(evt) => filterClickHandler(evt)}>{t('bar.mobile.filters')}</span>
        </div>
        <div className='px-3'>
          <FontAwesomeIcon className='text-[#f6d79c] text-2xl cursor-pointer' title='Email' icon={faEnvelope} onClick={() => setShow(true)} />
        </div>
      </div>
      <EmailModal show={show} setShow={(bool) => setShow(bool)} />
    </div>
  );
}

Bar.propTypes = {};

Bar.defaultProps = {};

export default Bar;
